import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { DwSecurityUserService } from '@devwareapps/devware-cap';
import { Observable, Subject } from 'rxjs';
import { Folder } from '../../models/folder';

@Component({
  selector: 'app-folder',
  templateUrl: './folder.component.html',
  styleUrls: ['./folder.component.scss']
})
export class FolderComponent implements OnInit, OnChanges {

  @Input() folders: Folder[];
  @Input() indent: number;
  @Input() init: boolean;
  @Input() events: Observable<void>;

  @Output() newItemEvent = new EventEmitter<number>();
  selectedFolderId: number;
  showChildrenvar: boolean;
  wachterUser: string[];
  eventsSubject: Subject<void> = new Subject<void>();
  oldFolders: Folder[];


  constructor(private securityService: DwSecurityUserService) { }

  ngOnInit(): void {
    this.wachterUser = this.securityService.securityContext.ApplicationUser.Permissions;
    this.events.subscribe(() =>{
      this.emitEventToChild();
      this.unselectAllFolders()
    })

  }
  ngOnChanges() {
    if(this.init){
      if(this.folders != undefined){
      this.resolveAfter2Seconds(this.folders).then(x =>{
      if(this.folders.length != 0 && this.folders != null && this.oldFolders != this.folders)
      {
        this.oldFolders = this.folders;
        this.initFolderSelect(this.folders[this.folders.indexOf(this.folders.filter(folder => folder.FolderName == 'Evaluation' || folder.FolderName.startsWith("PF"))[0])].FolderId);
      }
  });
      }
    }
  }

  initFolderSelect(FolderId: number){
    console.log(FolderId);
    this.selectedFolderId = FolderId;
    this.selectFolder(FolderId);
    this.newItemEvent.emit(this.selectedFolderId);


  }

  folderClicked(FolderId: number){
    console.log(FolderId);
    this.selectedFolderId = FolderId;
    this.selectFolder(FolderId);
    this.newItemEvent.emit(this.selectedFolderId);
    this.emitEventToChild();

  }

  emitEventToChild() {
    this.eventsSubject.next();
  }
  unselectAllFolders(){
    this.folders.forEach(folder => {
      var updateFolder = folder;
      updateFolder.selected = false;
      this.folders[this.folders.indexOf(folder)] = updateFolder;
    });
  }

  selectFolder(FolderId: number){
    this.folders.forEach(folder => {
      var updateFolder = folder;
      updateFolder.selected = false;
      this.folders[this.folders.indexOf(folder)] = updateFolder;
    });
    if (this.folders.filter(folder => folder.FolderId == FolderId).length != 0){
    let updateItem = this.folders.filter(folder => folder.FolderId == FolderId)[0];
    let index = this.folders.indexOf(updateItem);
    updateItem.selected = true;
    this.folders[index] = updateItem;
    console.log(this.selectedFolderId);
    console.log(this.folders);}
  }

  folderSelected(folderId: number){
    console.log(folderId);
    this.selectedFolderId = folderId;
    this.selectFolder(folderId);
    this.newItemEvent.emit(this.selectedFolderId);
  }

  showChildren(){
    this.showChildrenvar = !this.showChildrenvar;
  }

  resolveAfter2Seconds(x) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(x);
      }, 1000);
    });
  }

}
